<template>
<div>
    <v-col class="my-0 py-0 px-0 px-md-8 pb-15">
        <v-col class="text-start mt-5 mb-3">
            <v-alert text dense color="#8061c2" border="left" class="pl-5">
                <h1 class="title mt-1">Ganancias</h1>
                <p class="desc mt-0 mb-1">Listado de creadores con ganancias acumuladas sin cobrar.</p>
                <v-chip
                class="mt-2 mr-2"
                color="#388E3C"
                label
                outlined
                >Total ganancias: &nbsp; <strong>{{ profits.profits }}</strong> </v-chip>
                <v-chip
                class="mt-2 mr-2"
                color="#f44336"
                label
                outlined
                >Total retirado: &nbsp; <strong>{{ profits.payment }}</strong> </v-chip>
            </v-alert>
        </v-col>

        <!-- Search Bar y Filtros -->
        <v-row class="mx-3">
            <v-col cols="12" md="4" class="px-0">
                <v-text-field v-model="search" @input="fetchUsersEarnings" color="#8061c2" label="Buscar" append-icon="mdi-magnify" single-line hide-details outlined class="mb-2 mx-0 px-0"></v-text-field>
            </v-col>

            <v-col cols="12" md="4" class="px-md-2 px-0">
                <v-select
                    v-model="filter"
                    :items="filterOptions"
                    label="Filtrar por"
                    outlined
                    hide-details
                ></v-select>
            </v-col>

            <v-col cols="12" md="4" class="pr-md-2 px-0">
                <v-select v-model="order" :items="orderOptions" label="Ordenar" outlined hide-details></v-select>
            </v-col>
        </v-row>

        <!-- Tabla de datos -->
        <v-data-table :headers="headers" :items="users" :loading="loading" class="elevation-1 mx-3 px-2 py-4" :items-per-page="perPage" :server-items-length="totalUsers" :page.sync="page" :footer-props="{
          itemsPerPageOptions: [50, 100, 200, -1], 
          showFirstLastPage: true
        }" @update:page="fetchUsersEarnings" @update:items-per-page="changePerPage">
            <!-- Columnas y Templates -->

            <template v-slot:item.logo_path="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-avatar
                            size="40"
                            class="clickable-avatar"
                            @click="showLogo(item.logo_path)"
                            @mouseover="hoveredLogo = item.logo_path"
                            @mouseleave="hoveredLogo = null"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-img :src="item.logo_path" v-if="item.logo_path"></v-img>
                            <v-avatar v-else color="black">
                            <span class="white--text">{{ item.first_name.charAt(0) }}{{ item.last_name.charAt(0) }}</span>
                            </v-avatar>
                        </v-avatar>
                    </template>
                    <span>Ver Imagen</span>
                </v-tooltip>
            </template>

            <template v-slot:item.first_name="{ item }">
                {{ item.first_name }} {{ item.last_name }}
            </template>

            <template v-slot:item.email="{ item }">
                {{ item.email }}
            </template>

            <template v-slot:item.total_earnings="{ item }">
                $ {{ item.total_earnings }} USD
            </template>

            <template v-slot:item.all_earnings="{ item }">
                $ {{ item.all_earnings }} USD
            </template>

            <template v-slot:item.earnings_paid="{ item }">
                $ {{ item.earnings_paid }} USD
            </template>

            <!-- Botones de acciones -->
            <template v-slot:item.actions="{ item }">

                 <!-- Botón de check -->
                 <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            icon 
                            :color="item.configured_check === null ? 'grey' : (item.configured_check ? 'green' : 'red')" 
                            v-bind="attrs" 
                            v-on="on" 
                            @click="toggleCheck(item)"
                        >
                            <v-icon>mdi-check-circle</v-icon>
                        </v-btn>
                    </template>
                    <span>
                        {{ item.configured_check === null ? 'Marcar' : (item.configured_check ? 'Desmarcar' : 'Marcar') }}
                    </span>
                </v-tooltip>

                <!-- Botón para impersonar usuario -->
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon color="rgb(128 97 194)" v-bind="attrs" v-on="on" @click="impersonateUser(item.id)">
                            <v-icon>mdi-account-switch</v-icon>
                        </v-btn>
                    </template>
                    <span>Impersonar Usuario</span>
                </v-tooltip>

               
            </template>
        </v-data-table>

        <!-- Modal para ampliar el logo -->
        <v-dialog v-model="dialog" max-width="14rem" class="rounded-lg">
            <v-img :src="selectedLogo" width="14rem"></v-img>
        </v-dialog>

    </v-col>
</div>
</template>

<script>
import axios from '@/axios.js';
import impersonationMixin from '@/mixins/impersonationMixin';

export default {
    name: 'UserEarnings',
    mixins: [impersonationMixin],
    data() {
        return {
            users: [],
            search: '',
            loading: true,
            dialog: false,
            selectedLogo: null,
            page: 1,
            perPage: 50,
            totalUsers: 0,
            totalGanancias: 0,
            totalPayment: 0,
            order: 'desc',
            filter: 'earnings',
            filterOptions: [
                { text: 'Ganancias', value: 'earnings' },
            ],
            orderOptions: [{
                    text: 'Mayor',
                    value: 'desc'
                },
                {
                    text: 'Menor',
                    value: 'asc'
                }
            ],
            headers: [
                {
                    text: 'Avatar',
                    value: 'logo_path',
                    align: 'start'
                },
                {
                    text: 'Creador',
                    value: 'first_name',
                    align: 'start'
                },
                {
                    text: 'Correo',
                    value: 'email',
                    align: 'start'
                },
                {
                    text: 'Ganancias',
                    value: 'total_earnings',
                    align: 'start'
                },
                {
                    text: 'Retirado',
                    value: 'earnings_paid',
                    align: 'start'
                },
                {
                    text: 'Total',
                    value: 'all_earnings',
                    align: 'start'
                },
                {
                    text: 'Vistas',
                    value: 'total_views',
                    align: 'start'
                },
                {
                    text: 'Acciones',
                    value: 'actions',
                    sortable: false
                }
            ]
        };
    },
    watch: {
        order(newVal, oldVal) {
        if (newVal !== oldVal) {
            this.fetchUsersEarnings();
        }
        },
        filter(newVal, oldVal) {
        if (newVal !== oldVal) {
            this.fetchUsersEarnings();
        }
        }

    },
    computed: {
        profits() {
            const totalProfits = Number(this.totalGanancias);
            const totalPayment = Number(this.totalPayment);
            if (!isNaN(totalProfits) && !isNaN(totalPayment)) {
                return {
                    profits: `$${totalProfits.toLocaleString('en-US')} USD`,
                    payment: `$${totalPayment.toLocaleString('en-US')} USD`
                }
            }else{
                    return 'No hay saldo';
            }
        }
    },
    created() {
        this.fetchUsersEarnings();
    },

    methods: {

        logs(user) {
            // Construir la URL
            const path = this.$router.resolve({
                name: 'Logs',
                query: {
                    user_email: user.email,
                    type: 'monetization'
                }
            });

            // Abrir en nueva pestaña
            window.open(path.href, '_blank');
        },

        showLogo(logoPath) {
            this.selectedLogo = logoPath ? logoPath : require('../../assets/illustrations/no-photo.jpg');
            this.dialog = true;
        },

        async fetchUsersEarnings() {
            this.loading = true;
            try {
                const response = await axios.get('/admin/get-earnings', {
                    params: {
                        page: this.page,
                        per_page: this.perPage,
                        search: this.search,
                        order: this.order
                    }
                });
                this.users = response.data.data;
                this.totalUsers = response.data.total;
                this.totalGanancias = response.data.totalGanancias;
                this.totalPayment = response.data.totalPayment;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        async toggleCheck(user) {
            try {
                const newStatus = user.configured_check === null || !user.configured_check;
                await axios.post('/admin/toggle-check', {
                    user_id: user.id,
                    configured_check: newStatus
                });
                user.configured_check = newStatus; // Actualizar el estado localmente
            } catch (error) {
                console.error('Error al cambiar el estado de configured_check:', error);
            }
        },
        changePerPage(newPerPage) {
            this.perPage = newPerPage;
            this.page = 1;
            this.fetchUsersEarnings();
        },
    }
};
</script>

<style scoped>
.clickable-avatar:hover {
    transform: scale(1.2);
    transition: transform 0.3s ease;
}

.title {
    font-size: 22px !important;
    color: #8061c2;
}

.desc {
    color: #737373;
    font-size: 15px;
}
</style>
